/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getAuditLog} from '../api'

 export const useQueryGetAuditLog = createReactQueryHook('getAuditLog', getAuditLog)
